import { Imports, ITextOptions } from "../base/editor.interfaces";
import {fabric} from "fabric";



/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;
const SF = globalImports.SF || {};
SF.Editor = SF.Editor || {};
globalImports.SF.Editor = globalImports.SF.Editor || {};

// Turn off inline editing in the mobile editor...
globalImports.SF.Editor.Text = fabric.util.createClass(globalImports.SF.Editor.Text, {
    className: 'text-customizer',
    initialize: function (text: string, options: ITextOptions): void {

        this.callSuper('initialize', text, options, !fabric.isLikelyNode && text === '' && options.edited);
        // Handles case-sensitive differences in DefaultText among all environments
    },

    /**
     * Aborts cursor animation and clears all timeouts
     */
    abortCursorAnimation: function(): void {
        // const shouldClear = this._currentTickState || this._currentTickCompleteState;
        // const canvas = this.canvas;
        // tslint:disable-next-line:no-unused-expression
        this._currentTickState && this._currentTickState.abort();
        // tslint:disable-next-line:no-unused-expression
        this._currentTickCompleteState && this._currentTickCompleteState.abort();

        clearTimeout(this._cursorTimeout1);
        clearTimeout(this._cursorTimeout2);

        this._currentCursorOpacity = 0;
        // fabricjs removes contextTop at this point which causes canvas to flicker when typing, and it also removes the image wraps upon mouse down/up (PS-62551)

    },

    exitEditing: function (skipEmptyToDefault:boolean = false): void {
        if (!skipEmptyToDefault && this.text.trim() === '') {
            const defaultText = globalImports.SF.Model.DefaultText as { [key: string]: any };
            if (!this.addedByUser) {
                this.edited = false;
                if (!this.placeHolderTranslations) {
                    if (this.adjustedTextSize) {
                        this.text = defaultText[this.adjustedTextSize];
                    } else {
                        this.text = defaultText['small'];
                    }
                } else {
                    this.text = this.placeHolderTranslations[this.getCurrentLanguage()];
                }
            } else {
                this.textBeforeEdit = this.text;
                this.text = this.adjustedTextSize ? defaultText[this.adjustedTextSize] : defaultText['small'];
            }
        }
        if (SF.Util.Translator.getSaveTextPreview()) {
            SF.Util.Translator.getPreviewImageFromTextAsBase64(this).then(toDataURL => {
                this.preview_image = toDataURL;
                this.callSuper('exitEditing', skipEmptyToDefault);
            }, err => {
                console.error('Error getting preview image from text', err);
                this.callSuper('exitEditing', skipEmptyToDefault);
                throw err;
            });
        } else {
            this.callSuper('exitEditing', skipEmptyToDefault);
        }

    },

});